import React from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { s } from '../Style.jsx';

const Checkout = ({ auth, setOrders, setError, onComplete, order, setPaying }) => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        event.preventDefault();
        const result = await stripe.confirmPayment({
            elements,
            confirmParams: { 
                return_url: "https://theversatileexpress.com/order?view=" + order.id,
            },
        });

        console.log(result);

        if (result.error) {
            setError(result.error.message);
        }

        if(result.status === "succeeded") {
            onComplete(result);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3 style={{ marginBottom: 10 }}><s.BackArrow does={() => setPaying(false)} /> Credit Card Details</h3>
            <div>
                <PaymentElement />
            </div>
            <div style={{ flexDirection: "row-reverse", display: "flex", justifyContent: "space-between", marginTop: 10 }}>
                <button
                    style={{ marginTop: 10, padding: "10px 20px", border: "1px outset #000", fontWeight: "bold", borderRadius: 4, backgroundColor: "rgb(203, 33, 33)", cursor: "pointer", color: "white" }}
                    disabled={!stripe}>Submit</button>
            </div>
        </form>
    )
};
export default Checkout;